import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTopSellingProducts,
  searchOrdersReportsByFiltersApi,
} from "../../service/api_calls/ordersReports/OrderReportsAPi";
import { searchOrdersReportsByFiltersMultiBranchApi } from "../../service/api_calls/multiBranchOrdersReports/multiBranchOrdersReportsAPi";

const initialState = {
  orderReportsData: {
    count: 0,
    totalOrderSales: 0,
    details: [],
  },
  // orderReportsData:null,
  orderdata: {
    count: 0,
    totalOrderSales: 0,
    details: [],
  },
  orderReportsDataPageNo: 1,
  orderReportsDataLoader: false,

  topSellingProducts: null,
  topSellingProductsLoader: false,

  refreshTabData: 1,
};

// Get All Orders
export const getOrderReportsDataMultiBranch = createAsyncThunk(
  "getOrderReportsDataMultiBranch",
  async (param, thunkAPI) => {
    const res = await searchOrdersReportsByFiltersMultiBranchApi({
      ...param,
    });
    console.log("getOrderReportsDataMultiBranch123", res);

    return res;
  }
);

export const getTopSellingProductsData = createAsyncThunk(
  "getTopSellingProductsData",
  async (param, thunkAPI) => {
    const res = await getTopSellingProducts(param);
    console.log("getTopSellingProductsData", res);

    return res;
  }
);

export const multiBranchOrderReports = createSlice({
  name: "multiBranchOrderReports",
  initialState,
  reducers: {
    clearorderReportsInfoMB: (state) => {
      state.orderdata = {
        count: 0,
        totalOrderSales: 0,
        details: [],
      };
      state.orderReportsDataPageNo = 1;
    },

    handleRefreshTabDataMB: (state) => {
      state.refreshTabData = state.refreshTabData + 1;
    },
  },
  extraReducers: {
    //fetch Orders
    [getOrderReportsDataMultiBranch.pending]: (state) => {
      state.orderReportsDataLoader = true;
    },
    [getOrderReportsDataMultiBranch.fulfilled]: (state, { payload }) => {
      const orderData = payload?.details || [];
      console.log("payload", orderData);

      const orderInfo = orderData?.details || [];
      console.log("orderInfo", orderInfo);

      console.log("PAGE___DATA__Orderstate", {
        ...orderData,
        details: [...state.orderdata?.details, ...orderInfo],
      });

      if (orderInfo.length > 0) {
        state.orderdata = {
          ...orderData,
          details: [...state.orderdata?.details, ...orderInfo],
        };
        // state.orderReportsData = [...state.orderReportsData, ...orderData];
        state.orderReportsDataPageNo = state.orderReportsDataPageNo + 1;
      }
      state.orderReportsDataLoader = false;
    },
    [getOrderReportsDataMultiBranch.rejected]: (state) => {
      state.orderReportsDataLoader = false;
    },

    //TopSelling Products
    [getTopSellingProductsData.pending]: (state) => {
      state.topSellingProductsLoader = true;
      state.topSellingProducts = null;
    },
    [getTopSellingProductsData.fulfilled]: (state, { payload }) => {
      state.topSellingProducts = payload?.details;
      state.topSellingProductsLoader = false;
    },
    [getTopSellingProductsData.rejected]: (state, { payload }) => {
      state.topSellingProductsLoader = false;
      state.topSellingProducts = null;
    },
  },
});

export const { clearorderReportsInfoMB, handleRefreshTabDataMB } =
  multiBranchOrderReports.actions;

export const multiBranchOrderReportsReducer = multiBranchOrderReports.reducer;
